// ----------------------------------------------------------------------------
// Section: Day / Night Pack Split
// ----------------------------------------------------------------------------
// Presentational only — hosts two static Day / Night Pack Split Card blocks
// (see src/blocks/day-night-pack-split-card.liquid). No interaction/motion.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_day-night-pack-split.scss';